import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../api";
import Layout from "../components/Layout";
import Seo, { JsonLd } from "../components/Seo";

export default function JourneyDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api(`/api/packages/${slug}`).then(setItem).catch((err) => setError(err.message));
  }, [slug]);
  if (error) {
    return <Layout><section className="section"><p className="error">{error}</p></section></Layout>;
  }
  if (!item) return <Layout><section className="section">Loading journey…</section></Layout>;
  return (
    <Layout>
      <Seo title={item.seoTitle || item.title} description={item.seoDescription || item.summary} path={`/journeys/${item.slug}`} image={item.heroImage} />
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        name: item.title,
        description: item.summary,
        touristType: "Private travelers",
        offers: { "@type": "Offer", price: item.price, priceCurrency: item.currency },
      }} />
      <header className="article-hero" style={{ backgroundImage: `linear-gradient(transparent, rgba(0,0,0,.55)), url(${item.heroImage})` }}>
        <div className="wrap">
          <p className="eyebrow">{item.days} days · from {item.currency} {item.price}</p>
          <h1 className="display">{item.title}</h1>
          <p>{item.tagline}</p>
        </div>
      </header>
      <section className="section">
        <div className="wrap split">
          <div>
            <p className="kicker">{item.region}</p>
            <p className="lead">{item.summary}</p>
            <p style={{ marginTop: 18 }}><Link className="btn" to={`/enquire?journey=${encodeURIComponent(item.title)}`}>Enquire about this journey</Link></p>
          </div>
          <ul>
            {item.highlights?.map((point) => <li key={point}>{point}</li>)}
          </ul>
        </div>
        <div className="wrap itinerary" style={{ marginTop: 48 }}>
          {item.itinerary?.map((day) => (
            <article className="day" key={day.day}>
              <p className="kicker">Day {String(day.day).padStart(2, "0")}</p>
              <h3>{day.title}</h3>
              <ul>{day.activities?.map((line) => <li key={line}>{line}</li>)}</ul>
              <div className="meta-row">
                {day.accommodation ? <span>Stay: {day.accommodation}</span> : null}
                {day.meals ? <span>Meals: {day.meals}</span> : null}
                {day.travelTime ? <span>Time: {day.travelTime}</span> : null}
                {day.transfer ? <span>{day.transfer}</span> : null}
              </div>
            </article>
          ))}
        </div>
      </section>
    </Layout>
  );
}
